"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.enable = void 0;
const utils_1 = require("../utils");
/**
 * Enables the Analytics category to permit the transmission of events.
 *
 * @note
 * Analytics is enabled by default. You do not need to call this API unless you have disabled Analytics.
 */
exports.enable = utils_1.enableAnalytics;
